export default "__VITE_ASSET__BuJM8I7e__"